<div class="file-upload-container">
  <!-- Title -->
  <h5 class="upload-title">{{ title | translate }}</h5>

  <!-- Drop Zone -->
  <div
    class="drop-zone"
    [class.drag-over]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="openFileDialog()">

    <div class="drop-zone-content">
      <p class="drop-text">{{ 'Transfer the file to this area' | translate }}</p>
      <p class="or-text">{{ 'or' | translate }}</p>
      <a class="select-link" (click)="$event.stopPropagation(); openFileDialog()">
        {{ 'Select files to upload' | translate }}
      </a>
    </div>

    <input
      type="file"
      id="fileInput"
      [accept]="accept"
      [multiple]="multiple"
      (change)="onFileInputChange($event)"
      style="display: none;">
  </div>

  <!-- Progress Bar (shown when uploading) -->
  @if (uploadedFiles.length > 0 && !uploadedFiles[0].uploaded) {
    <div class="progress-container">
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="uploadedFiles[0].progress">
        </div>
      </div>
      <div class="progress-info">
        <span class="progress-percentage">{{ uploadedFiles[0].progress }}%</span>
        <span class="progress-spinner">
          <i class="pi pi-spin pi-spinner"></i>
        </span>
      </div>
    </div>
  }

  <!-- Uploaded Files List -->
  @if (uploadedFiles.length > 0) {
    <div class="uploaded-files-section">
      <h4 class="uploaded-title">{{ 'Uploaded files' | translate }}</h4>

      <div class="uploaded-files-list">
        @for (file of uploadedFiles; track file.name) {
          <div class="file-item">
            <div class="file-icon-wrapper">
              <i [class]="getFileIcon(file.format)" class="file-icon"></i>
            </div>

            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-format">{{ file.format }}</div>
            </div>

            <button
              class="remove-btn"
              (click)="removeFile(file)"
              [attr.aria-label]="'Remove file' | translate"
              [disabled]="isRemoveDisabled">
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
      </div>
    </div>
  }

</div>
